import React from 'react';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import OrganizationModal from './components/OrganizationModal';

import './Organizations.styles.scss';

const Organizations = ({ controller }) => (
  <div className="Organizations">
    {controller.selectedOrganization && (
      <OrganizationModal
        organization={controller.selectedOrganization}
        onClose={controller.handleCloseOrganizationModal}
        onSubmit={controller.handleOrganizationSubmit}
      />
    )}

    <div className="header">
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={controller.handleCreateOrganizationPress}
      >
        Create Organization
      </Button>
    </div>

    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Organization Name</TableCell>
            <TableCell>Code</TableCell>
            <TableCell>Owner</TableCell>
            <TableCell>Members</TableCell>
            <TableCell>Created</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {controller.organizations.length < 1 && <TableCell>No active organizations</TableCell>}
          {controller.organizations.map((organization) => (
            <TableRow key={organization.id}>
              <TableCell>{organization.name}</TableCell>
              <TableCell>{organization.affiliate.code}</TableCell>
              <TableCell>
                {organization.user.firstName} {organization.user.lastName}
              </TableCell>
              <TableCell>{organization.memberCount}</TableCell>
              <TableCell>
                {moment(organization.createTime).format('MMM DD, YYYY (HH:mm)')}
              </TableCell>
              <TableCell className="actions-cell">
                <IconButton onClick={() => controller.handleUpdateOrganizationPress(organization)}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => controller.handleDeleteOrganizationPress(organization)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={controller.errors.length > 0}
      autoHideDuration={6000}
      onClose={controller.handleErrorsClose}
    >
      <Alert severity="error">{controller.errors.join(', ')}</Alert>
    </Snackbar>
  </div>
);

export default Organizations;
